import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { FaLock } from "react-icons/fa";
import { useHistory } from "react-router-dom";
import { Button } from "react-bootstrap";

import { Auth } from "services/action";

import { Page, Input } from "ui/components";
import reset from "../../../assets/reset.png";

const ResetPasswordScreen = ({ location }) => {
  const Dispatch = useDispatch();
  const History = useHistory();
  const StateForm = useSelector((state) => state.Form);

  const [password, setPassword] = React.useState("");
  const [confirmPassword, setConfirmPassword] = React.useState("");

  const $handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      password: password,
      confirm_password: confirmPassword,
      reset_token: location?.state?.token,
    };
    const req = await Dispatch(Auth.$resetPassword(payload));

    if (req?.message === "success") {
      History.push({
        pathname: "/signin",
        state: {
          is_reset: true,
        },
      });
    }
  };

  return (
    <Page className="bg-container-image ">
      <div className="mt-3 mb-3 d-flex align-items-center justify-content-center">
        <img src={reset} alt="" height={200} />
      </div>

      <div>
        <div style={{ fontSize: 20, fontWeight: 700, textAlign: "left" }}>
          Lupa Kata Sandi?
        </div>
        <div className="mt-2 mb-2" style={{ textAlign: "left" }}>
          Silakan atur ulang kata sandi anda.
        </div>

        <form onSubmit={$handleSubmit}>
          <div className="form-group">
            <Input
              icon={<FaLock />}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              type="password"
              placeholder="masukkan kata sandi anda"
              error={StateForm?.errors?.password}
              lg
            />
          </div>
          <div className="form-group">
            <Input
              icon={<FaLock />}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              type="password"
              placeholder="ulangi kata sandi anda"
              error={StateForm?.errors?.confirm_password}
              lg
            />
          </div>

          <Button
            type="submit"
            variant="primary"
            className="w-100 mt-3 p-2 border border-primary fs-7"
            disabled={StateForm?.loading}
          >
            {!StateForm?.loading ? (
              "Selanjutnya"
            ) : (
              <div className="spinner-border" role="status"></div>
            )}
          </Button>
        </form>

        <div className="page-pretitle text-secondary mt-2 text-center cursor-pointer">
          Kembali ke{" "}
          <span
            className="text-primary"
            onClick={() => History.push("/signin")}
          >
            Halaman Masuk
          </span>
        </div>
      </div>
    </Page>
  );
};

export default ResetPasswordScreen;
